<template>
  <div class="instruct-wrapper">
    <div class="instuctor-process-options">
      <WidgetToolbar title="Instructor" :icon="require('@/assets/admin-icon/menu/instructor_active.svg')">
        <div class="options row">
          <widgetSearch placeholder="Search here..." icon="right" v-model="filter_form.query" @keyup="searchStudent">
          </widgetSearch>
          <div class="h-spacer"></div>
          <classDropdown :school="$getLoggedUser().company_name" @onSubmit="getSelectedClass">
            <span class="selected-class" v-if="!filter_form.class">
              All Departments
            </span>
            <span class="selected-class" v-else>{{
              filter_form.class.data.name
            }}</span>
          </classDropdown>
          <div class="v-line-divider" style="height: 40px"></div>

          <div class="filter-select-widget">
            <filter-select @onSubmit="sortSchoolStudent" v-model="filter_form.sort_by" :content="view_filter">
              <div class="filter-selected-label">
                <span v-if="filter_form.sort_by == 'all_student'">All Student</span>
                <span v-if="filter_form.sort_by == 'matched'">Matched</span>
                <span v-if="filter_form.sort_by == 'not_matched'">Not Matched</span>
                <span v-if="filter_form.sort_by == 'signed_contract'">Signed Contract</span>
              </div>
            </filter-select>
          </div>
          <div class="h-spacer"></div>

          <DropdownButton v-if="!show_selected_student_options" class="green" @onSubmit="remindAll" :content="[
            { name: 'All Students', value: 'all_student' },
            // { name: 'All Company', value: 'all_company' },
          ]">Remind</DropdownButton>

          <widgetButton v-if="show_selected_student_options" @click="matchSelectedStudent()" class="btn-secondary">
            Match
          </widgetButton>

          <div v-if="show_selected_student_options" class="h-spacer"></div>

          <widgetButton v-if="show_selected_student_options" @click="signSelectedStudent()" class="btn-primary">
            Contract Signed?
          </widgetButton>

          <div v-if="show_selected_student_options" class="h-spacer"></div>
          <dropdown-menu class="table-menu" v-if="show_selected_student_options">
            <ul>
              <li>
                <a @click.prevent="remindSelectedStudent()">Remind</a>
              </li>
              <li>
                <app-dialog title="Delete Student" ask="Are you sure you want to delete selected student?" yesText="Yes"
                  noText="No" @onComfirm="deleteSelectedStudent()">
                  <a>Delete</a>
                </app-dialog>
              </li>
            </ul>
          </dropdown-menu>
          <div class="h-spacer"></div>
          <div class="table-options">
            <SchoolNotifiation></SchoolNotifiation>
          </div>
        </div>
      </WidgetToolbar>
    </div>
    <div class="instruct-widget">
      <instructorProcessMenus></instructorProcessMenus>

      <div class="instruct-list">
        <div class="instruct-body" @scroll="onPageScoll"
          v-if="student_data && student_data.data.length > 0 && !isLoading">
          <table class="table-data">
            <thead class="table-header">
              <tr>
                <th class="stick-title">
                  <div class="force-start">
                    <input v-model="isAllStudentSelected" @change="checkAllStudent" type="checkbox" />
                    Name
                  </div>
                </th>
                <th class="stick-title">Email</th>
                <th class="stick-title">LIA</th>
                <th class="stick-title">Matching</th>
                <th class="stick-title">Contract</th>
                <th class="stick-title" width="90">More actions</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <template>
                <tr v-for="(item, index) in student_data.data" :key="index" class="row-data">
                  <td>
                    <div class="profile-content">
                      <input @change="checkStudent" v-model="item.checked" class="checkbox" type="checkbox" />
                      <widgetProfile :title="item.first_name + ' ' + item.last_name"
                        :subtitle="item.profile ? item.profile.address : ''" :file_name="item.profile_picture"
                        :path="$fullUrl('images/profiles/')"></widgetProfile>
                    </div>
                  </td>
                  <td class="email">{{ item.email }}</td>
                  <td>
                    <div class="applied-internships row" v-if="item.applied_internships"
                      @click="showAppliedInternship(item)">
                      <div v-for="(inter, ind) in item.applied_internships" :key="ind" v-if="ind < 4"
                        class="applied-internship row">
                        <widgetProfile
                          :class="{ active: inter.id != item.internship_id, primary: inter.id == item.internship_id && !inter.published }"
                          :title="inter.name" :subtitle="inter.location"
                          :showContent="item.applied_internships.length == 1" file_name="" :size="19" :text_size="9"
                          path=""></widgetProfile>
                      </div>
                      <div v-if="item.applied_internships.length > 4" class="applied-internship row">
                        and More
                      </div>
                    </div>
                  </td>
                  <td>
                    <widgetButton v-if="!item.match_sent && !item.matched" @click="matchStudent(item)"
                      class="btn-secondary">
                      Match
                    </widgetButton>

                    <widgetBadget v-if="item.match_sent && !item.matched" class="badge-secondary" text="Awaiting">
                    </widgetBadget>

                    <widgetBadget v-if="item.matched" class="badge-primary" text="Matched">
                      <img class="icon" src="@/assets/icons/confirm_green.svg" />
                    </widgetBadget>
                  </td>
                  <td>
                    <widgetButton v-if="!item.contract_signed" :class="{ disabled: !item.matched }"
                      @click="signContract(item)" class="btn-secondary">
                      Contract Signed ?
                    </widgetButton>

                    <widgetBadget v-else class="badge-primary" text="Contract Signed">
                      <img class="icon" src="@/assets/icons/confirm_green.svg" />
                    </widgetBadget>
                  </td>
                  <td>
                    <div class="center">
                      <dropdown-menu class="table-menu">
                        <ul>
                          <li v-if="item.match_sent && !item.matched">
                            <a @click.prevent="matchStudent(item)">Match</a>
                          </li>
                          <li>
                            <a @click.prevent="remindOption('student', item)">Remind Student</a>
                          </li>
                          <!-- <li>
                          <a @click.prevent="remindOption('company', item)"
                            >Remind Company</a
                          >
                        </li>
                        -->
                          <li>
                            <a @click.prevent="viewProfile(item)">View Profile</a>
                          </li>
                          <li>
                            <a @click.prevent="sendMessage(item)">Send Message</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Student" ask="Are you sure you want to delete this student?"
                              yesText="Delete" noText="Cancel" @onComfirm="deleteStudent(item)">
                              <a>Delete Student</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <!-- loading on pagination -->
          <div class="loading-paginated-items" v-if="isLoadingDataOnPagination">
            <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="isLoadingDataOnPagination"
              :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
          </div>
        </div>
        <!-- Loading preview -->
        <div class="loading-widget" v-if="isLoading">
          <loading :height="40" :width="40" :active="true" color="#1ba5a4" background-color="#fff"
            :is-full-page="false" />
        </div>

        <div v-if="student_data && student_data.data.length == 0 && !isLoading" class="student-not-found-widget">
          <widgetNotFoundWidget title="No Students Found"
            content="You need to complete the previous step to get students on this step">
            <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
          </widgetNotFoundWidget>
        </div>
      </div>
    </div>

    <!-- Reminder modal -->
    <remainderModal v-if="show_remainder" :user="user_to_remaind" :type="remind_type" phase="phase_3"
      @close="closeRemainder">
    </remainderModal>

    <!-- Applied internship modal -->
    <studentAppliedInternships v-if="show_applied_internships" :user="selected_user"
      @close="show_applied_internships = false"></studentAppliedInternships>
  </div>
</template>

<script>
import { eventBus } from "@/main";

import studentAppliedInternships from "@/views/Instructor/components/modals/student_applied_internships.vue";
import instructorProcessMenus from "./widgets/instructorProcessMenus.vue";
import remainderModal from "../components/modals/remainderModal.vue";
export default {
  name: "",
  components: {
    studentAppliedInternships,
    instructorProcessMenus,
    remainderModal,
  },
  props: {
    formFilter: {
      type: Object,
      default: () => {
        return {
          class: null,
          id: null,
          id_type: "",
          sort_by: "all",
          query: "",
        };
      },
    },
  },
  data: () => {
    return {
      view_filter: [
        {
          value: "all_student",
          name: "All Students",
        },
        {
          value: "matched",
          name: "Matched",
        },
        {
          value: "not_matched",
          name: "Not Matched",
        },
        {
          value: "signed_contract",
          name: "Signed Contract",
        },
      ],
      student_data: null,
      filter_form: {
        id: null,
        id_type: "",
        sort_by: "all_student",
        query: "",
        class: null,
        url_type: "",
        next_page_url: "",
      },
      show_remainder: false,
      user_to_remaind: null,
      remind_type: "student",
      submit_changes_loading: false,
      show_selected_student_options: false,
      isLoading: false,
      show_applied_internships: false,
      selected_user: [],
      isAllStudentSelected: false,
      isLoadingDataOnPagination: false,
    };
  },
  mounted() {
    let vm = this;
    vm.filter_form.class = vm.formFilter.class;
    vm.filter_form.id = vm.formFilter.id;
    vm.filter_form.id_type = vm.formFilter.id_type;
    vm.filter_form.query = vm.formFilter.query;
    vm.getAllStudent();
  },
  computed: {},
  watch: {},
  methods: {
    // =====================================
    onPageScoll({ target }) {
      let vm = this;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (
          !vm.isLoadingDataOnPagination &&
          vm.student_data.current_page < vm.student_data.last_page
        ) {
          vm.getAllStudent("next");
        }
      }
    },
    searchStudent(e) {
      let vm = this;
      vm.$emit("saveFilter", "query", e.target.value);
      vm.isAllStudentSelected = false;
      vm.getAllStudent();
    },
    sortSchoolStudent() {
      let vm = this;
      vm.isAllStudentSelected = false;
      vm.getAllStudent();
    },
    getSelectedClass(item) {
      let vm = this;
      vm.isAllStudentSelected = false;
      if (item.type == "school") {
        vm.filter_form.class = null;
        vm.filter_form.id = null;
        vm.filter_form.id_type = item.type;
        vm.$emit("saveFilter", "class", null);
        vm.$emit("saveFilter", "id", null);
        vm.$emit("saveFilter", "id_type", item.type);
        vm.getAllStudent();
      } else {
        vm.filter_form.class = item;
        vm.filter_form.id = item.data.id;
        vm.filter_form.id_type = item.type;
        vm.$emit("saveFilter", "class", item);
        vm.$emit("saveFilter", "id", item.data.id);
        vm.$emit("saveFilter", "id_type", item.type);
        vm.getAllStudent();
      }
    },
    getAllStudent(type = "init") {
      let vm = this;
      if (type == "init") {
        vm.isLoading = true;
      }

      vm.isLoadingDataOnPagination = true;
      vm.filter_form.url_type = type;
      vm.filter_form.next_page_url = vm.student_data
        ? vm.student_data.next_page_url
        : "";
      vm.$store
        .dispatch("GET_ALL_SCHOOL_STUDENT_PHASE3", vm.filter_form)
        .then((responce) => {
          vm.isLoading = false;
          vm.isLoadingDataOnPagination = false;
          responce.data.data = responce.data.data.map((item) => {
            if (vm.isAllStudentSelected) {
              eventBus.$set(item, "checked", true);
            } else {
              eventBus.$set(item, "checked", false);
            }
            item.applied_internships = item.applied_internships.map(
              (internship) => {
                let full_location = "";
                if (Array.isArray(internship.location)) {
                  internship.location.forEach((location) => {
                    full_location += location + ", ";
                  });
                }
                eventBus.$set(internship, "location", full_location);
                return internship;
              }
            );
            return item;
          });
          if (type == "init") {
            vm.student_data = responce.data;
            if (vm.student_data.current_page < vm.student_data.last_page) {
              vm.getAllStudent("next");
            }
          } else {
            vm.student_data.next_page_url = responce.data.next_page_url;
            vm.student_data.current_page = responce.data.current_page;
            vm.student_data.last_page = responce.data.last_page;
            responce.data.data.forEach((item) => {
              vm.student_data.data.push(item);
            });
          }
          vm.validateCheckedStudent();
        })
        .catch((error) => {
          vm.isLoadingDataOnPagination = false;
          vm.isLoading = false;
        });
    },
    validateCheckedStudent(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_student_options =
          vm.student_data.data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.student_data.data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkAllStudent({ target }) {
      let vm = this;
      vm.isAllStudentSelected = target.checked;
      if (target.checked) {
        vm.student_data.data = vm.student_data.data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.student_data.data = vm.student_data.data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedStudent();
    },
    checkStudent() {
      let vm = this;
      vm.isAllStudentSelected = false;
      vm.validateCheckedStudent();
    },
    // ======================================
    matchSelectedStudent() {
      let vm = this;
      let payload = vm.student_data.data
        .filter((item) => item.checked == true && item.matched == false)
        .map((item) => {
          return {
            student_id: item.id,
            copy_id: item.copy,
          };
        });
      vm.$store
        .dispatch("INSTRUCTOR_MATCH_SCHOOL_SELECTED_STUDENT", {
          students: payload,
          isAllStudentSelected: vm.isAllStudentSelected,
          filter: vm.filter_form,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Match request is now sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    deleteSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_DELETE_SELECTED_PHASE1", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected student have been deleted",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    remindSelectedStudent() {
      let vm = this;
      vm.user_to_remaind = vm.validateCheckedStudent("ids");
      vm.remind_type = "checked";
      vm.show_remainder = true;
    },
    signSelectedStudent() {
      let vm = this;
      let payload = vm.student_data.data
        .filter((item) => item.checked == true && item.matched == true)
        .map((item) => {
          return {
            student_id: item.id,
            copy_id: item.copy,
          };
        });
      vm.$store
        .dispatch("INSTRUCTOR_SIGN_CONTRACT_OF_SELECTED_STUDENT", {
          students: payload,
          isAllStudentSelected: vm.isAllStudentSelected,
          filter: vm.filter_form,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Contract status is now updated",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    // =============================
    selectPath(item) {
      let vm = this;
      vm.$router.push({
        name: "instructor",
        params: { main_menu: item.main_name, sub_menu: item.name },
      });
    },
    viewProfile(item) {
      let item_id = window.btoa(item.id);
      let name =
        item.first_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item.last_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item_id;
      window.parent.postMessage(
        {
          message: "routeNow",
          value: {
            name: "consultant-public-profile",
            params: { name: name },
          },
        },
        "*"
      );
    },
    sendMessage(item) {
      window.parent.postMessage({ message: "sendMessage", value: item }, "*");
    },
    showAppliedInternship(user) {
      let vm = this;
      vm.selected_user = user;
      vm.show_applied_internships = true;
    },
    deleteStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_DELETE_SCHOOL_STUDENT", {
          student_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Student is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    remindOption(value, item) {
      let vm = this;
      vm.user_to_remaind = item;
      vm.remind_type = value;
      vm.show_remainder = true;
    },
    remindAll(value) {
      let vm = this;
      vm.remind_type = value;
      vm.show_remainder = true;
    },
    sendRemainder(item) {
      let vm = this;
      vm.remind_type = "student";
      vm.user_to_remaind = item;
      vm.show_remainder = true;
    },
    closeRemainder() {
      let vm = this;
      vm.show_remainder = false;
    },
    matchStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_MATCH_SCHOOL_STUDENT", {
          student_id: item.id,
          copy_id: item.copy,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Match request is now sent",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    signContract(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_STUDENT_CONTRACT_SIGNED", {
          student_id: item.id,
          copy_id: item.copy,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Contract status is now updated",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.instruct-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;

  .instuctor-process-options {
    position: absolute;
    top: 5px;
    right: 5px;
    left: 5px;
  }

  .instruct-widget {
    height: 100%;
    position: relative;

    .custom-resizer {
      height: 100%;
    }

    .instruct-list {
      display: flex;
      flex-direction: column;
      height: calc(100% - 57px);
      min-width: calc(100% - 300px);
      width: 100%;
      position: relative;

      .loading-widget {
        background: #fff;
        padding: 10px 10px;
        height: 100%;
        position: relative;
        border-radius: 5px;
        overflow: hidden;
      }

      .student-not-found-widget {
        background: #fff;
        padding: 10px 10px;
        height: 100%;
        position: relative;
        border-radius: 5px;
        overflow: hidden;
        display: flex;

        .notfound-wrapper {
          width: 100%;

          .notfound-widget {
            width: 500px;
          }
        }
      }

      .instruct-body {
        background: #fff;
        height: 100%;
        overflow-y: auto;
        padding-bottom: 60px;
        border-radius: 5px;
        padding: 10px;

        .table-data {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;

          tr {
            &.row-data {
              background: #fff;
            }

            &:hover {
              background: rgb(248, 248, 248);
              cursor: pointer;
            }

            th {
              &.stick-title {
                position: sticky;
                top: 0px;
                z-index: 999;
              }

              &.center {
                display: flex;
                align-content: center;

                input {
                  position: relative;
                  top: 0px;
                  margin-right: 5px;
                  margin: 0px 20px;
                }
              }

              .force-start {
                display: flex;
                align-items: center;

                input {
                  position: relative;
                  top: -1px;
                  left: -7px;
                  margin-right: 5px;
                }
              }

              &.text-center {
                text-align: center;
              }
            }

            td {
              .checkbox {
                position: relative;
                top: -1px;
                left: -7px;
                margin-right: 5px;
              }

              .invitation-status {
                padding: 13px 10px;
                width: 150px;
                border-radius: 10px;
                text-align: center;

                &.received {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }

                &.singed {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }

                &.sent {
                  border: 1px solid #0884af;
                  color: #0884af;
                }
              }

              .profile-content {
                display: flex;
                align-items: center;
              }

              .btn-match {
                width: 150px;
                height: 50px;
                background: #0884af;
                border-radius: 10px;
                color: #fff;
              }

              .btn-sign-contract {
                width: 150px;
                height: 50px;
                background: #1ba5a4;
                border-radius: 10px;
                color: #fff;

                &.disabled {
                  background: #ccc;
                  color: #fff;
                  cursor: not-allowed;
                  pointer-events: none;
                }
              }

              &.email {
                color: #334d6eb0;
              }

              .company-profile-widget {
                display: flex;
                align-content: center;

                .internship-owner-image {
                  border-radius: 50%;
                }

                img {
                  width: 30px;
                  height: 30px;
                  margin-right: 7px;
                }

                .company-info {
                  display: flex;
                  flex-direction: column;

                  h2,
                  p {
                    margin: 0px;
                  }

                  h2 {
                    font-size: 13px;
                    color: #000;
                  }

                  p {
                    font-size: 11px;
                    color: #464646;
                  }
                }
              }

              .applied-internships {
                background: #f7f7f7;
                border-radius: 5px;
                padding: 2px;
                margin: 3px 10px;
              }

              .menu {
                width: 100%;
                display: flex;
                justify-content: center;

                button {
                  padding: 0px;
                  position: relative;
                  left: -3px;

                  img {
                    width: 15px;
                  }
                }
              }

              .match-status {
                padding: 13px 10px;
                width: 150px;
                border-radius: 10px;
                text-align: center;

                img {
                  margin-left: 10px;
                }

                &.matched {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }

                &.unmatched {
                  border: 1px solid #0884af;
                  color: #0884af;
                }
              }

              .center {
                display: flex;
                justify-content: center;
              }

              &:first-child {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
              }

              &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
              }

              &.text-center {
                text-align: center;
              }

              .btn-invite {
                width: 74px;
                height: 50px;
                background: #0884af;
                border-radius: 10px;
                color: #fff;
              }

              .btn-approve {
                width: 74px;
                height: 50px;
                background: #1ba5a4;
                border-radius: 10px;
                color: #fff;
              }
            }
          }
        }

        .loading-paginated-items {
          height: 50px;
          position: relative;
        }
      }
    }

    .instruct-details {
      width: 260px;
      min-width: 260px;
      max-width: 300px;
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
      border-radius: 5px;

      .instruct-header {
        font-size: 24px;
        text-align: center;
        padding-top: 20px;

        h1 {
          margin: 0px;
          font-size: 25px;
          font-weight: 500;
        }
      }

      .chart-widget {
        height: 32%;
        width: 100%;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .header {
          padding: 10px 10px;
          color: #333333;
          text-align: center;
        }

        .body {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .footer {
          padding: 10px 10px;
          display: flex;
          justify-content: space-between;

          .label-widget {
            .box-widget {
              display: flex;
              align-items: center;

              .box {
                height: 24px;
                width: 24px;
                background: #0884af;
                border-radius: 50%;
                margin-right: 7px;

                &.active {
                  background: #1ba5a4;
                }
              }

              .label {
                font-size: 13px;
                position: relative;
                top: 3px;
              }
            }

            .label-info {
              margin-top: 8px;
              text-align: center;
            }
          }
        }
      }

      .empty-widget {
        display: flex;
        align-content: center;
        justify-content: center;

        h1 {
          font-size: 20px;
          color: #ddd;
          margin-top: 200px;
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 20px;
  }

  .student-not-found-widget {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 5px;
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
